import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import bindAll from 'lodash.bindall';
import LibraryComponent from '../../../components/library/library-no-modal';

class ClazzList extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    handleItemSelect(item) {
        this.props.history.push("class?id=" + item.extensionId);
    }
    render() {
        let items = this.props.items.map(item=>({
            extensionId: ''+item.id,
            id: item.id,
            name: item.name,
            rawURL: item.cover || `${window.config.staticURL}/cover/class/default.png`,
            //iconURL: ""
            //insetIconURL: ""
            featured: true,
            description: item.school_name,
        }));
        return (
            <React.Fragment>
                <LibraryComponent
                    data={items}
                    filterable={false}
                    id="ClassLibrary"
                    title="班级列表"
                    visible={true}
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            </React.Fragment>
        );
    }
}

ClazzList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    onRequestClose: PropTypes.func
}

export default withRouter(ClazzList);
